import styled from 'styled-components'
import { getIconContainerStyles } from '../style'
import { StyledIconContainerProps } from '../type'

const StyledIconContainer = styled.div.withConfig({
    shouldForwardProp: (prop) => !['theme'].includes(prop)
})<StyledIconContainerProps>(({ theme }) => getIconContainerStyles({ theme }))

export default StyledIconContainer
